import alertc from './Alert.vue'
import { createApp } from 'vue'
var alertApp = null,
  timer = null
const alert = {
  install: function (app) {
    app.config.globalProperties.$alert = alert
  },
  show(o, second = 1500, callback) {
    if (alertApp) {
      alertApp.hide()
      clearTimeout(timer)
      timer = null
    }
    // const second = 1500
    if (typeof o == 'string') {
      o = { text: o }
      timer = setTimeout(() => {
        alertApp.hide()
        clearTimeout(timer)
        timer = null
        o.close && o.close()
        callback && callback()
      }, second)
    }
    alertApp = createApp(alertc, o).mount(document.createElement('div'))
    document.body.appendChild(alertApp.$el)
  },
  getActType() {
    if (alertApp && alertApp.isShow) {
      return alertApp.type
    } else {
      return false
    }
  },
  getMsg() {
    if (alertApp && alertApp.isShow) {
      return alertApp.text
    } else {
      return ''
    }
  },
  close() {
    if (alertApp) {
      alertApp.hide()
      clearTimeout(timer)
      timer = null
    }
  }
}
export default alert
